/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const InputForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
`;
